import { UploadOutlined } from '@ant-design/icons';
import { Button, message, UploadFile } from 'antd';
import { AuthResult, AzureBlobResponse } from './azure-upload';
import { AzureUploadContainer } from './azure-upload.container';
import { FileValidator } from './file-validator';
import { RcFile} from 'antd/lib/upload/interface';

interface FileUploadButtonProps {
  authorizeRequest: (file: File) => Promise<AuthResult>;
  onChange?: (value: any) => void;
  onRemoveRequested?: () => Promise<boolean>;
  onInvalidContentType?: () => void;
  onInvalidContentLength?: () => void;
  permittedContentTypes?: string[];
  permittedExtensions?: string[];
  maxFileSizeBytes?: number;
  maxWidthOrHeight?: number;
  onSuccess?: (response: AzureBlobResponse, file: UploadFile) => Promise<void>;
  onError?: () => void;
  button?: React.ReactNode;
  maxFileCount?: number;
  buttonText?: string;
  isIcon?: boolean;
  uploadImage?: boolean;
  isProcessing?: boolean;
  hasNewFileUploaded?: boolean;
  cropperProps?: object;
  disabled?: boolean;
  cropAllowed?: boolean;
}

export const FileUploadButton: React.FC<FileUploadButtonProps> = ({ isIcon = false, uploadImage = true, cropAllowed = true, ...props }) => {
  const handleOnSuccess = async (response: AzureBlobResponse, file: UploadFile) => {
    if (props.onSuccess) {
      await props.onSuccess(response, file);
    }
  };

  const beforeCrop = async (file: RcFile) => {
    const validator = new FileValidator(file, {
      permittedContentTypes: props.permittedContentTypes,
      maxFileSizeBytes: props.maxFileSizeBytes,
      maxWidthOrHeight: props.maxWidthOrHeight
    });

    const result = await validator.validate();
    if (!result.success || file.type === 'application/pdf') {
      return false;
    }

    return true;
  };

  return (
    <AzureUploadContainer
      data={{
        permittedContentTypes: props.permittedContentTypes,
        permittedExtensions: props.permittedExtensions,
        maxFileSizeBytes: props.maxFileSizeBytes,
        maxWidthOrHeight: props.maxWidthOrHeight
      }}
      authorizeRequest={props.authorizeRequest}
      onInvalidContentType={
        props.onInvalidContentType
          ? props.onInvalidContentType
          : () => {
              message.error('Files of that content type are not permitted');
            }
      }
      onInvalidContentLength={
        props.onInvalidContentLength
          ? props.onInvalidContentLength
          : () => {
              message.error('PDF File Size should not exceed 10MB');
            }
      }
      onRemoveRequested={props.onRemoveRequested}
      onSuccess={handleOnSuccess}
      onError={(error: any) => {
        console.error('Error uploading asset: ', error);
        props.onError && props.onError();
      }}
      uploadProps={{
        onChange: props.onChange
      }}
      maxFileCount={props.maxFileCount}
      buttonText={props.buttonText}
      uploadPreviewImage={uploadImage}
      cropperProps={cropAllowed ? {...props.cropperProps, beforeCrop}: undefined}
    >
      <Button type="primary" disabled={props.disabled} loading={props.isProcessing} style={{ marginTop: '10px', minWidth: '160px' }}>
        {isIcon && <UploadOutlined />} {props.buttonText ? props.buttonText : 'Upload File'}
      </Button>
    </AzureUploadContainer>
  );
};
